// Wybór planu i potwierdzenie płatności po rejestracji. Mockup nie ma tych ekranów, więc cały
// plik to tłumaczenie własne. Nazwy planów (Starter, Professional, Enterprise) i kody
// promocyjne przychodzą z API i nie są tłumaczone; komunikat `error` przy złym kodzie też.
//
// VERIFY: cały plik.
export default {
  selectPlan: {
    title: 'Wybierz plan',
    subtitle: 'Wybierz plan, który najlepiej odpowiada potrzebom organizacji.',
    mostPopular: 'Najpopularniejszy',
    // Klucze to nazwy planów z API zapisane camelCase (mapa w select-plan.tsx).
    taglines: {
      starter: 'Podstawowe narzędzia na start',
      professional: 'Wszystko, czego potrzeba do rozwoju',
      enterprise: 'Rozwiązania szyte na miarę dla dużych zespołów',
    },
    features: {
      topics: 'Analiza tematów',
      sentiment: 'Analiza sentymentu',
      translation: 'Tłumaczenie',
      advancedAnalytics: 'Zaawansowana analityka',
    },
    // Liczba dni przechowywania nagrań; polski ma cztery formy liczby mnogiej.
    audioRetention_one: 'Przechowywanie nagrań: {{count}} dzień',
    audioRetention_few: 'Przechowywanie nagrań: {{count}} dni',
    audioRetention_many: 'Przechowywanie nagrań: {{count}} dni',
    audioRetention_other: 'Przechowywanie nagrań: {{count}} dnia',
    // Etykiety interwału rozliczeniowego; wartości `month` i `year` to kontrakt z API.
    interval: {
      month: 'mies.',
      year: 'rok',
    },
    promo: {
      label: 'Masz kod promocyjny?',
      placeholder: 'Wpisz kod',
      // Fallbacki, gdy backend nie odesłał własnej treści błędu.
      invalid: 'Nieprawidłowy kod',
      validationFailed: 'Nie udało się zweryfikować kodu',
    },
    checkoutFailed: 'Nie udało się rozpocząć płatności. Spróbuj ponownie.',
    continueWith: 'Kontynuuj z planem {{name}}',
  },
  success: {
    title: 'Płatność zakończona pomyślnie!',
    activating: 'Aktywowanie subskrypcji…',
    active: 'Subskrypcja jest aktywna. Przekierowanie na Pulpit…',
  },
} as const;
